var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, PacemEventTarget, Utils } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemVibrateElement = class PacemVibrateElement extends PacemEventTarget {
    vibrate() {
        if (this.disabled) {
            return;
        }
        const pattern = this.pattern;
        if (!Utils.isNullOrEmpty(pattern)) {
            if (typeof navigator.vibrate === 'function') {
                navigator.vibrate(pattern);
            }
        }
    }
};
__decorate([
    Watch({
        emit: false, converter: {
            convert: (attr) => attr?.split(/[ ,]+/).map(i => parseInt(i)),
            convertBack: (prop) => prop?.join(' ')
        }
    })
], PacemVibrateElement.prototype, "pattern", void 0);
PacemVibrateElement = __decorate([
    CustomElement({ tagName: P + '-vibrate' })
], PacemVibrateElement);
export { PacemVibrateElement };
